<template>
  <div :class="classes">
    <Heading
      v-if="titleContent"
      :content="titleContent"
      size="large"
      tag="h2"
      role="headline"
    />
    <div class="footer-contact-items">
      <FooterContactItem
        v-for="(item, index) in contactItems"
        :key="index"
        v-bind="item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import {
  default as FooterContactItem,
  type FooterContactItemProps,
} from 'ewi-ui/components/2-molecules/FooterContactItem';
import './FooterContact.scss';

export interface FooterContactProps {
  titleContent?: string;
  contactItems: FooterContactItemProps[];
}

withDefaults(defineProps<FooterContactProps>(), {
  titleContent: 'Title',
  contactItems: () => [],
});

const classes = computed(() => ({
  'footer-contact': true,
}));
</script>
